import { render, staticRenderFns } from "./GraphBubbles.vue?vue&type=template&id=6624014c&"
import script from "./GraphBubbles.vue?vue&type=script&lang=js&"
export * from "./GraphBubbles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports